
<app-shared [type]="'inventaire'" [status]="'broullion'"></app-shared>
